import React from 'react';

const Icon = ({ size = '51', fill = 'black', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 51 51" fill="none" {...other}>
            <path
                clipRule="evenodd"
                d="M9.414 11.167c0-1.15.933-2.083 2.083-2.083h29.167c1.15 0 2.083.933 2.083 2.083v29.167c0 1.15-.932 2.083-2.083 2.083H11.497a2.083 2.083 0 0 1-2.083-2.083V11.167Z"
                stroke={fill}
                strokeWidth="1.875"
            />

            <path
                d="M22.515 32.429c-2.045-.64-3.084-2.433-2.781-4.796.206-1.618 1.231-2.788 2.134-3.821.405-.462.785-.899 1.08-1.35 1.207-1.86 1.491-3.547 1.445-4.825 2.221 1.919 3.649 3.623 4.437 5.276a.8.8 0 0 0 1.066.378.8.8 0 0 0 .379-1.067 11.403 11.403 0 0 0-.427-.804c.031.016.055.04.09.052a.8.8 0 0 0 1.014-.501c.03-.09.055-.189.074-.294.637.836 1.377 1.922 1.955 3.111a.8.8 0 0 0 1.07.37c.397-.192.52-.652.368-1.069-1.104-3.056-3.56-5.099-3.651-5.193a.8.8 0 0 0-1.365.666c.093.69.13 1.614.035 1.894a.747.747 0 0 0-.033.26c-1.213-1.809-3.085-3.68-5.78-5.779a.805.805 0 0 0-1.207.999c.05.102 1.222 2.514-.814 5.655-.23.357-.576.75-.942 1.167l-.027.033a.782.782 0 0 0 .046-.697c-.24-.558-1.277-2.067-2.417-2.494a.792.792 0 0 0-.865.22c-.22.24-.267.6-.128.893.024.05.558 1.23-.8 3.327-.11.17-.246.355-.392.554-.71.978-1.782 2.458-1.782 4.52 0 .878.204 3.805 2.835 4.631a.799.799 0 1 0 .48-1.526c-1.59-.5-1.715-2.504-1.715-3.105 0-1.542.82-2.672 1.478-3.58.163-.224.313-.431.438-.624.665-1.026.982-1.918 1.11-2.653.139.19.242.36.29.47a.802.802 0 0 0 1.052.417c.063-.026.11-.072.161-.113-.953 1.1-2.032 2.46-2.28 4.4-.402 3.146 1.088 5.647 3.892 6.526a.8.8 0 1 0 .477-1.528Z"
                fill={fill}
            />

            <path
                d="M30.388 23.95c-3.345 0-5.974 2.628-5.974 5.973 0 3.345 2.629 5.974 5.974 5.974s5.974-2.629 5.974-5.974c0-3.346-2.748-5.974-5.974-5.974Zm0 10.75a4.792 4.792 0 0 1-4.779-4.778 4.792 4.792 0 0 1 4.78-4.78 4.792 4.792 0 0 1 4.778 4.78 4.792 4.792 0 0 1-4.779 4.779Z"
                fill={fill}
            />

            <path
                d="M32.418 27.89a.579.579 0 0 0-.837 0l-1.255 1.255-1.255-1.255a.579.579 0 0 0-.837 0 .577.577 0 0 0 0 .837l1.255 1.255-1.255 1.255a.579.579 0 0 0 0 .837.579.579 0 0 0 .837 0l1.255-1.255 1.255 1.255c.239.238.716.238.837 0a.579.579 0 0 0 0-.837l-1.255-1.255 1.255-1.255a.576.576 0 0 0 0-.837Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
